import { DateRangeValue } from "@/utils/dateUtils";
import { useCallback, useMemo } from "react";

export const usePreviousTimeFrame = (timeFrame: DateRangeValue) => {
  const calculatePreviousTimeFrame = useCallback((currentTimeFrame: DateRangeValue): { from: Date; to: Date } => {
    const duration = currentTimeFrame.to.getTime() - currentTimeFrame.from.getTime();
    const previousTo = new Date(currentTimeFrame.from.getTime() - 1); // Subtract 1ms to not overlap
    const previousFrom = new Date(previousTo.getTime() - duration);

    return {
      from: previousFrom,
      to: previousTo
    };
  }, []);

  const previousTimeFrame = useMemo(() => {
    return calculatePreviousTimeFrame(timeFrame)
  }, [timeFrame])

  return previousTimeFrame;
}
